// eslint-disable-next-line no-restricted-imports
import sjcl from 'js/lib/sjcl';
import 'js/lib/sjcl-codecHex';
import 'js/lib/sjcl-sha1';

export function hashToHex(value: string): string {
  // eslint-disable-next-line import/no-named-as-default-member
  return sjcl.codec.hex.fromBits(sjcl.hash.sha1.hash(value));
}
